import api from '../../../services/api';

const BASE_URL = '/batches';

const batchService = {
  async getBatches(params = {}) {
    const response = await api.get(BASE_URL, { params });
    return response.data.data;
  },

  async getBatchById(batchId) {
    const response = await api.get(`${BASE_URL}/${batchId}`);
    return response.data.data.batch;
  },

  async createBatch(batchData) {
    const response = await api.post(BASE_URL, batchData);
    return response.data.data.batch;
  },

  async updateBatch(batchId, batchData) {
    const response = await api.patch(
      `${BASE_URL}/${batchId}`,
      batchData
    );

    return response.data.data.batch;
  },
};

export default batchService;